import actions from './actions';

const initState = {
  transactions: [],
  bills: [],
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.LIST_TRANSACTIONS_SUCCESS:
      return {...state, transactions: [...action.payload]};

    case actions.LIST_BILLS_SUCCESS:
      return {...state, bills: [...action.payload]};
  
    default:
      return state;
  }
}
